import validatorService from '@/utils/validatorService'
import { mapState, mapMutations } from 'vuex'

const validateCPFMixin = {
  data() {
    return {
      statusCPFValidate: null,
      textCPFValidate: '',
    }
  },
  computed: {
    ...mapState('Checkout', {
      disabledStateBtn: (state) => state.disabledStateBtn,
    }),
  },
  mounted() {
    this.SET_DISABLED_STATE_PAYMENT(true)
  },
  beforeDestroy() {
    this.SET_DISABLED_STATE_PAYMENT(false)
  },
  methods: {
    ...mapMutations('Checkout', ['SET_DISABLED_STATE_PAYMENT']),
    validateCPF(setDisabledOrEnabled = true) {
      if (!this.payment.document) {
        if (setDisabledOrEnabled) this.SET_DISABLED_STATE_PAYMENT(true)
        this.statusCPFValidate = 'error'
        this.textCPFValidate = this.$t('steps.validators.required')
        throw new Error(this.textCPFValidate)
      }

      if (
        !validatorService.validateCPF(this.payment.document) ||
        (this.payment.document.length > 0 && this.payment.document.length < 13)
      ) {
        if (setDisabledOrEnabled) this.SET_DISABLED_STATE_PAYMENT(true)
        this.statusCPFValidate = 'error'
        this.textCPFValidate = this.$t('steps.validators.invalid.document.invalidDocument')
        throw new Error(this.textCPFValidate)
      }

      if (setDisabledOrEnabled) this.SET_DISABLED_STATE_PAYMENT(false)
      this.statusCPFValidate = 'success'
      this.textCPFValidate = ''

      return true
    },
    validateDNI(setDisabledOrEnabled = true, countryCode = 'BR') {
      if (!['AR', 'UY'].includes(countryCode)) {
        return true
      }

      if (!this.payment.document) {
        if (setDisabledOrEnabled) this.SET_DISABLED_STATE_PAYMENT(true)
        this.statusCPFValidate = 'error'
        this.textCPFValidate = this.$t('steps.validators.required')
        throw new Error(this.textCPFValidate)
      }

      if (
        this.payment.document.length > 0 &&
        (countryCode === 'AR'
          ? this.payment.document.length < 9
          : this.payment.document.length < 11)
      ) {
        if (setDisabledOrEnabled) this.SET_DISABLED_STATE_PAYMENT(true)
        this.statusCPFValidate = 'error'
        this.textCPFValidate = this.$t('steps.validators.invalid.document.invalidDNI')
        throw new Error(this.textCPFValidate)
      }

      if (setDisabledOrEnabled) this.SET_DISABLED_STATE_PAYMENT(false)
      this.statusCPFValidate = 'success'
      this.textCPFValidate = ''

      return true
    },
  },
}

export default validateCPFMixin
